<i18n>
{
    cn: {
        news: "新闻",
        business_cooperation: "商务合作",
        join_us: "加入我们",
        super: "速珮传媒",
        ambassador: "奢颜艺术图库（PC)",
        address: "上海 · 洛杉矶 · 纽约 · 米兰 · 新加坡",
        terms: "服务条款",
        copyright: "版权信息",
        privacyPolicy: "隐私政策",
        beian: "沪ICP  备180000000号-8"
    },
    en: {
        news: "News",
        business_cooperation: "Business Collaboration",
        join_us: "Join Us",
        super: "Super Media",
        ambassador: "Ambassador+ ART Portfolio",
        address: "Shanghai · Los Angeles · New York · Milan · Singapore",
        terms: "Terms of Service",
        copyright: "Copyright Information",
        privacyPolicy: "Privacy Policy",
        beian: "SH ICP No. 1800000-8"
    }
}
</i18n>
<script>
export default {
    name: "Footer",
    data() {
        return {
            qrcode: [
                {
                    name: 'xhs',
                    icon: require('@/assets/images/icon_footer_xhs.png'),
                    qrcode: require('@/assets/images/qrcode_xhs.jpg')
                },
                {
                    name: 'wb',
                    icon: require('@/assets/images/icon_footer_wb.png'),
                    qrcode: require('@/assets/images/qrcode_wb.jpg')
                },
                {
                    name: 'wx',
                    icon: require('@/assets/images/icon_footer_wx.png'),
                    qrcode: require('@/assets/images/qrcode_wx.jpg')
                },
                {
                    name: 'dy',
                    icon: require('@/assets/images/icon_footer_dy.png'),
                    qrcode: require('@/assets/images/qrcode_dy.jpg')
                },
                {
                    name: 'xd',
                    icon: require('@/assets/images/icon_footer_xd.png'),
                    qrcode: require('@/assets/images/qrcode_xd.jpg')
                },
            ]
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="footer">
        <div class="layout_main">
            <div class="flex justify_between align_end wrapper">
                <div class="links">
                    <div class="list flex">
                        <div class="item">
                            <router-link to="/news">{{ $t('news') }}</router-link>
                            <a href="//supermediachina.com/" target="_blank">{{ $t('super') }}</a>
                        </div>
                        <div class="item">
                            <router-link to="/contactUs">{{ $t('business_cooperation') }}</router-link>
                            <a href="https://www.zenulla.com/" target="_blank">ZenuIIa Inc.</a>
                        </div>
                        <div class="item">
                            <a>{{ $t('join_us') }}</a>
                            <a href="//www.ambassadorplus-ip.com/" target="_blank">{{ $t('ambassador') }}</a>
                        </div>
                    </div>
                    <p class="address">{{ $t('address') }}</p>
                    <div class="email flex align_center">
                        <img :src="require('@/assets/images/icon_email.png')" alt="" class="icon"/>
                        <a href="mailto:tinagao@supermediachina.com">tinagao@supermediachina.com</a>
                    </div>
                </div>
                <div class="qrcode_group flex">
                    <div class="item flex align_center" v-for="(item, index) in qrcode" :key="index" :class="item.name">
                        <img :src="item.icon" alt="" class="icon"/>
                        <div class="popup">
                            <div class="qrcode"><img :src="item.qrcode" alt=""/></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="line"></div>
            <div class="beian flex justify_center">
                <p><router-link to="/terms">{{ $t('terms') }}</router-link></p>
                <p><router-link to="/copyright">{{ $t('copyright') }}</router-link></p>
                <p><router-link to="/privacyPolicy">{{ $t('privacyPolicy') }}</router-link></p>
                <p>{{ $t('beian') }}</p>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.footer{
    background: #000;
    padding: .4rem 0 .6rem;
    color: #fff;
    @media only screen and (max-width: 750px) {
        padding: .5rem 0 .7rem;
    }
    .wrapper{
        @media only screen and (max-width: 750px) {
            flex-direction: column;
            align-items: center;
            .links{
                width: 100%;
                text-align: center;
            }
        }
    }
    .list{
        gap: .5rem;
        margin-bottom: .2rem;
        .item{
            display: flex;
            flex-direction: column;
            gap: .2rem;
            font-size: .16rem;
            line-height: 1.2;
            a,
            span{
                display: block;
            }
            :nth-of-type(1){
                font-size: .18rem;
            }
        }
        @media only screen and (max-width: 750px) {
            gap: 0;
            margin-bottom: .5rem;
            .item{
                flex: 1;
                align-items: center;
                font-size: .2rem;
                :nth-of-type(1){
                    font-size: .22rem;
                }
            }
        }
    }
    .address{
        font-size: .14rem;
        margin-bottom: .2rem;
        @media only screen and (max-width: 750px) {
            font-size: .16rem;
            margin-bottom: .3rem;
        }
    }
    .email{
        font-size: .14rem;
        .icon{
            width: .18rem;
            height: .15rem;
            margin-right: .05rem;
        }
        @media only screen and (max-width: 750px) {
            font-size: .18rem;
            justify-content: center;
            margin-bottom: .4rem;
        }
    }
    .qrcode_group{
        gap: .3rem;
        .item{
            position: relative;
            z-index: 1;
            &:hover{
                .popup{
                    visibility: visible;
                    opacity: 1;
                    transform: translate(-50%, 0);
                }
            }
            .icon{
                cursor: pointer;
            }
            .popup{
                position: absolute;
                left: 50%;
                bottom: 100%;
                transform: translate(-50%, -10%);
                padding-bottom: .2rem;
                visibility: hidden;
                opacity: 0;
                transition: opacity .3s, transform .3s, visibility .3s;
                .qrcode{
                    width: 1.2rem;
                    height: 1.2rem;
                    border-radius: .1rem;
                    background: #fff;
                    position: relative;
                    padding: .1rem;
                    img{
                        width: 100%;
                    }
                    &::after{
                        content: "";
                        border-left: .1rem solid transparent;
                        border-right: .1rem solid transparent;
                        border-top: .1rem solid #fff;
                        position: absolute;
                        top: 100%;
                        left: 50%;
                        transform: translate(-50%, 0);
                    }
                }
            }
        }
        .xhs{
            .icon{
                width: .66rem;
            }
            
        }
        .wb{
            .icon{
                width: .37rem;
            }
        }
        .wx{
            .icon{
                width: .38rem;
            }
        }
        .dy{
            .icon{
                width: .28rem;
            }
        }
        .xd{
            .icon{
                width: .3rem;
            }
        }
    }
    .line{
        border-bottom: 1px solid #777;
        margin: .25rem 0 .35rem;
    }
    .beian{
        gap: .5rem;
        font-size: .12rem;
        @media only screen and (max-width: 750px) {
            font-size: .16rem;
        }
    }
}
</style>